import request from './requestWrapper';

// Types
import {PaginationType} from '../types/sharedTypes';
import {AllianceType} from "../types/allianceTypes";


function getParams() {
  return request({
    url: 'alliance/getParams',
    method: 'GET',
  });
}
function getAll(data: PaginationType) {
  return request({
    url: 'alliance/getAll',
    method: 'GET',
    params: data
  });
}
function generateClientSecret(allianceId: string) {
  return request({
    url: `alliance/generateClientSecret/${allianceId}`,
    method: 'POST'
  });
}
function create(alliance: AllianceType) {
  return request({
    url: 'alliance/create',
    method: 'POST',
    data: alliance
  });
}
function update(alliance: AllianceType) {
  return request({
    url: 'alliance/update',
    method: 'PUT',
    data: alliance
  });
}
function remove(allianceId: string) {
  return request({
    url: `alliance/delete/${allianceId}`,
    method: 'DELETE',
  });
}

export default {
  getParams, getAll,
  create,
  generateClientSecret,
  update,
  remove
}